import { logOut } from './authHelpers';
import { getFlag } from './flags/getFlag';
import routes from './commonVariables/routes';
import {
    AppSectionsProfile,
    AppSectionsCore,
    AppSectionsZinantis,
    IAppConfigSections,
    AppSections,
    AppSectionsZitoneo,
} from '../types/appConfiguration/appConfigTypes';
import {
    CoreMenuItem,
    ProfileMenuItem,
    ZinantisMenuItem,
    ZitoneoMenuItem,
} from '../types/menus/menusTypes';
import { commonIcons } from './commonVariables/commonIcons';

export const menuPropertyPublic = [
    {
        name: 'property_service_desk',
        linkTo: routes.serviceDesk,
    },
    {
        name: 'fast_check_in',
        linkTo: routes.fastCheckIn,
    },

    {
        name: 'sign_up',
        linkTo: routes.signUp,
    },
    {
        name: 'log_in',
        linkTo: routes.login,
    },
];

export const menuPropertyPrivate = [
    {
        name: 'home',
        linkTo: routes.landingPrivate,
    },
    {
        name: 'property_service_desk',
        linkTo: routes.serviceDesk,
    },
    {
        name: 'fast_check_in',
        linkTo: routes.fastCheckIn,
    },
];

export const getProfileMenu = (
    isMenuVisible: boolean,
    pagesVisibility: IAppConfigSections[AppSections.PROFILE]['pages']
): ProfileMenuItem[] => {
    const items: ProfileMenuItem[] = [
        {
            text: 'account',
            icon: 'ManageAccountsOutlined',
            link:
                routes.landingPrivate +
                routes.accountSection +
                routes.accountInfo,
            visibilityKey: AppSectionsProfile.ACCOUNT,
        },
        {
            text: 'contacts',
            icon: 'PermContactCalendar',
            link:
                routes.landingPrivate +
                routes.accountSection +
                routes.profileContacts,
            visibilityKey: AppSectionsProfile.CONTACTS,
        },
        {
            text: 'payment_terms',
            icon: 'PaymentOutlined',
            link:
                routes.landingPrivate +
                routes.accountSection +
                routes.paymentTerms,
            visibilityKey: AppSectionsProfile.PAYMENT,
        },
        {
            text: 'settings',
            icon: 'SettingsOutlined',
            link:
                routes.landingPrivate + routes.accountSection + routes.settings,
            visibilityKey: AppSectionsProfile.SETTINGS,
        },
        { type: 'divider', text: 'divider' },
        {
            text: 'Logout',
            icon: 'LogoutOutlined',
            link: routes.login,
            onClick: logOut,
        },
    ];

    return items.filter(item => {
        if ('visibilityKey' in item && item.visibilityKey) {
            return isMenuVisible && pagesVisibility[item.visibilityKey];
        }
        return true;
    });
};

export const languagesMenu = [
    { text: 'en', Icon: getFlag(2), name: 'English', Id: 1 },
    { text: 'fr', Icon: getFlag(5), name: 'French', Id: 2 },
    { text: 'es', Icon: getFlag(3), name: 'Spanish', Id: 3 },
    { text: 'de', Icon: getFlag(4), name: 'German', Id: 4 },
];

export const getOwnerPortalMenu = (
    isMenuVisible: boolean,
    pagesVisibility: IAppConfigSections[AppSections.CORE]['pages']
): CoreMenuItem[] => {
    if (!isMenuVisible) return [];
    return [
        {
            icon: commonIcons.HOTEL,
            link: '/owner-portal/your-properties',
            text: 'properties',
            visibilityKey: AppSectionsCore.PROPERTIES,
        },
        {
            icon: 'Event',
            link: '/owner-portal/your-bookings',
            text: 'bookings',
            visibilityKey: AppSectionsCore.BOOKINGS,
        },
        {
            icon: commonIcons.TAX,
            link: '/owner-portal/taxes',
            text: 'taxes',
            visibilityKey: AppSectionsCore.TAXES,
        },
        {
            icon: commonIcons.SUPPLEMENT,
            link: '/owner-portal/supplements',
            text: 'supplements',
            visibilityKey: AppSectionsCore.SUPPLEMENTS,
        },
        {
            icon: 'Assignment',
            link: '/owner-portal/contracts',
            text: 'contracts',
            visibilityKey: AppSectionsCore.CONTRACTS,
        },
        {
            icon: commonIcons.STOP_SALE,
            link: '/owner-portal/stop-sales',
            text: 'stop_sales',
            visibilityKey: AppSectionsCore.STOP_SALES,
        },

        {
            icon: 'List',
            link: '/owner-portal/ari',
            text: 'Ari',
            visibilityKey: AppSectionsCore.ARI,
        },
    ].filter(item => pagesVisibility[item.visibilityKey]);
};

export const getZinantisMenu = (
    isMenuVisible: boolean,
    isAdminUser: boolean,
    pagesVisibility: IAppConfigSections[AppSections.ZINANTIS]['pages']
): ZinantisMenuItem[] => {
    if (!isMenuVisible || !isAdminUser) return [];

    return [
        {
            icon: 'CardMembershipOutlined',
            link: '/owner-portal/zinantis/members',
            text: 'members',
            visibilityKey: AppSectionsZinantis.MEMBERS,
        },
        {
            icon: 'Cable',
            link: '/owner-portal/zinantis/connection-requests',
            text: 'connection_requests',
            visibilityKey: AppSectionsZinantis.CONNECTION_REQUESTS,
        },
        {
            icon: 'Schema',
            link: '/owner-portal/zinantis/channel-managers',
            text: 'channel_managers',
            visibilityKey: AppSectionsZinantis.CHANNEL_MANAGERS,
        },
    ].filter(item => pagesVisibility[item.visibilityKey]);
};

export const getZitoneoMenu = (
    isMenuVisible: boolean,
    isAdminUser: boolean,
    pagesVisibility: IAppConfigSections[AppSections.ZITONEO]['pages']
): ZitoneoMenuItem[] => {
    if (!isMenuVisible || !isAdminUser) return [];
    return [
        {
            icon: 'Category',
            link: '/zitoneo/hotels-content',
            target: '_blank',
            text: 'hotel_content',
            visibilityKey: AppSectionsZitoneo.HOTEL_CONTENT,
        },
    ].filter(item => pagesVisibility[item.visibilityKey]);
};
